/**
 * Created by wwei on 2017-07-20.
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import { Button, Modal } from "antd";

class DeleteModal extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    delFunc: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    context: PropTypes.node,
    show: PropTypes.bool.isRequired
  };

  state = {
    deleting: false
  };

  close = () => {
    this.setState({ deleting: false });
    this.props.onClose();
  };

  doDelete = () => {
    this.setState({ deleting: true });
    this.props.delFunc();
  };

  render() {
    const { t, title, context, show } = this.props;
    const { deleting } = this.state;

    return (
      <Modal
        visible={show}
        title={title}
        closable={false}
        maskClosable={false}
        style={{ top: 140 }}
        footer={[
          <Button
            key="submit"
            type="danger"
            size="large"
            id="deleteBtn"
            loading={deleting}
            onClick={() => this.doDelete()}
          >
            {deleting ? t("COMMON.DELETING") : t("COMMON.DELETE")}
          </Button>,
          <Button
            key="cancel"
            size="large"
            onClick={() => this.close()}
            disabled={deleting}
          >
            {t("COMMON.CANCEL")}
          </Button>
        ]}
      >
        {context}
      </Modal>
    );
  }
}

export default translate()(DeleteModal);



// WEBPACK FOOTER //
// ./src/common/components/DeleteModal.js